import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { useTranslation } from "gatsby-plugin-react-i18next"
import forelli1 from "../../assets/img/forelli1.png"
import forelli2 from "../../assets/img/forelli2.png"

export default function ForelliProjesi() {
  const { t } = useTranslation()
  return (
    <Layout>
      <SEO title="Forelli Projesi" />
      <div className="projeler-container page">
        <div className="ic-proje">
          <img src={forelli1} alt="" className="proje-icGorsel" />
          <div className="proje-kunye">
            <span>{t("project-brand")}</span>: {t("forelli")}
            <br />
            <span>{t("project-sector")}</span>: {t("giyim")}
            <br />
            <span>{t("project-subject")}</span>: {t("sanat-projesi")}
            <br />
            <span>{t("project-artwork")}</span>: {t("bilal-akkaya-pr")}
          </div>
          <img src={forelli2} alt="" className="proje-icGorsel" />
        </div>
      </div>
    </Layout>
  )
}
